import script from "./carteiraView.vue?vue&type=script&setup=true&lang=ts"
export * from "./carteiraView.vue?vue&type=script&setup=true&lang=ts"

import "./carteiraView.vue?vue&type=style&index=0&id=7703a138&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7703a138"]])

export default __exports__